// Import the Set type
import React, { useEffect, useRef, useState } from 'react';
import { AppProvider } from '@shopify/polaris';
import PopularAppsCard from '../popular_appscards/popular_apps_cards';
import { getAllAppsDashboard } from '../..//services/seller/api';
import { useSelector } from 'react-redux';
import AppData from '../../components/interface/nav_bar_Interface/nav_bar_interface';
import { install2 } from '../../../assets/'
import "../../pages/sellerPages/seller_dashboard/seller.scss"
import { captureGAEvent, gaPanelConfig } from '../../shared/helper';
import { CircularProgress } from '@mui/material';
interface App {
  app_id: string;
  slug: string;
  app_icon: string;
  app_name: string;
  overall_rating: any;
  rating_count: any;
  short_description: string;
  developer_id: string;
  status: string;
  created_at: string;
  updated_at: string;
}

interface ApiResponse {
  data?: App[]; // Make data optional, as it might be undefined in case of an error
}

interface AllAppsProps {
  mainTitle: string;
  onAppCardClick: (slug: string, appName: string, appStatus: string, cardSection: string) => void;
}

const AllApps: React.FC<AllAppsProps> = ({ mainTitle, onAppCardClick }) => {
  const [showAll, setShowAll] = useState(false);
  const [loadedApps, setLoadedApps] = useState([] as App[]);
  const [currentPage, setCurrentPage] = useState(0);
  const [apiRefresh, setApiRefresh] = useState(false);

  const [shouldShowLoadMoreButton, setShowButton] = useState(false);
  const navSearchbardata: AppData[] | null = useSelector((state: { searchAppList: { data: AppData[] | null } }) => state.searchAppList.data);

  const prevLoadedApps = useRef<any[]>([]);
  const auth = useSelector((state: any) => state.auth);
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    const fetchAppAppsData = async (pageNumber: number) => {
      try {
        const response = await getAllAppsDashboard(pageNumber);
        if (response.data && Array.isArray(response.data)) {
          // Convert prevLoadedApps to a Set for efficient duplicate detection
          const uniqueApps = new Set(prevLoadedApps.current.map(app => app.app_id));

          // Filter out duplicates from the response data
          const filteredData = response.data.filter(app => !uniqueApps.has(app.app_id));

          // Append new response data to loadedApps
          setLoadedApps((prevApps) => [...prevApps, ...filteredData]);
        

          if (navSearchbardata) {

            const totalLoadedAppsLength = prevLoadedApps.current.length + filteredData.length;
            // console.log("Total apps length " + totalLoadedAppsLength);
            // console.log("Total searchlist length " + navSearchbardata.length);
            if (currentPage === 0 && filteredData.length === 6) {
              setShowButton(totalLoadedAppsLength !== navSearchbardata.length);
            }
            if (totalLoadedAppsLength === navSearchbardata.length) {
              setShowButton(false);
            }
            else if (currentPage > 0 && filteredData.length === 6) {
              setShowButton(true);
            }
            // Update prevLoadedApps to track the latest loaded apps
            prevLoadedApps.current = [...prevLoadedApps.current, ...filteredData];

            // Save prevLoadedApps to local storage
            localStorage.setItem('prevLoadedApps', JSON.stringify(prevLoadedApps.current));
          }
          else {
            console.error("Error: appData or app_id is undefined");
          }
        } else {
          console.error("Invalid data structure in the API response");
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
        // Handle error as needed
      } finally {
        setLoading(false)
        console.log("Data fetching completed.");
       
      }
    };

    fetchAppAppsData(currentPage);
    if (auth.token && !apiRefresh) {
      setLoading(true)
      setLoadedApps([]);
      prevLoadedApps.current = [];

      console.log("refresh all apps data")
      fetchAppAppsData(0);
      setApiRefresh(true)
   
    }
  }, [currentPage, navSearchbardata, auth.token]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
       <div style={{ marginTop: "10px", textAlign: "center" }}>
                <CircularProgress color="inherit" size={40} />
              </div>
      </div>
    );
  }

  // Check if navSearchbardata is null before rendering
  if (navSearchbardata === null) {
    return (
      <div>
        <div className="flex flex-col md:flex-row justify-center">Something went wrong</div>
      </div>
    );
  }


  // Filter out duplicate app IDs from loadedApps
  const uniqueLoadedApps = loadedApps.filter((app, index, self) =>
    index === self.findIndex((t) => (
      t.app_id === app.app_id
    ))
  );
  const appsPerPage = 6; // Number of apps displayed per page
  const totalPages = Math.ceil(uniqueLoadedApps.length / appsPerPage);
  // const handleSliderDotClick = (index) => {
  //   // Implement your logic here
  //   console.log(`Slider dot clicked: ${index}`);
  //   // You can perform actions like updating the current page state based on the clicked index
  // };


  const visibleApps = showAll ? uniqueLoadedApps : uniqueLoadedApps.slice(0, 6);

  const handleLoadMore = () => {
    gaPanelConfig.BtnText = "Load More";
    sendGAEvent('sras_load_more');
    setCurrentPage((prevPage) => prevPage + 1);
    setShowAll(true);

    // Disable the button if the length of navSearchbardata matches the length of loadedApps
    if (navSearchbardata && navSearchbardata!.length === uniqueLoadedApps.length) {
      setShowButton(false);
    }
  };
  const sendGAEvent = (event: string) => {
    captureGAEvent(event, event);
  };
  return (
    <>
      {/* First div - Hide on mobile view */}
      <div className="hidden md:block">
        {/* Content of the first div */}
        {currentPage === 0 && uniqueLoadedApps.length === 0 && uniqueLoadedApps.length === navSearchbardata!.length ? (
          // Render blank container when data is null on page 0
          <div style={{ padding: "20px", margin: "20px", }}>
            <AppProvider i18n={{}}>
              <div className="flex flex-col md:flex-row justify-center">Something went wrong</div>
            </AppProvider>
          </div>
        ) : currentPage === null && uniqueLoadedApps.length === null ? (
          // Render blank container when data is null on page 0
          <div style={{ padding: "20px", margin: "20px", }}>
            <AppProvider i18n={{}}>
              <div>Loading data....</div>
            </AppProvider>
          </div>
        ) : (
          // Render content when data is available



          <div className='container'>
            <div className='container'>
              <h1 style={{
                marginTop: "25px",
                fontSize: "35px",
                letterSpacing: "0px",
                opacity: "100",
                color: "#0B0757",
                fontFamily: "sfprobold"
              }}  >{loadedApps.length === 0 ? '' : mainTitle}</h1>
            </div>

            <div>
              <div style={{ marginTop: "20px", }} className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4'>
                {visibleApps.map((app, index) => (
                  <div key={index} style={{ position: "relative" }}>
                    {/* Image positioned above the right top of the card */}
                    {app.status === "Installed" && (
                      <img
                        src={install2}
                        alt="image"
                        className="absolute top-8 transform -translate-y-1/2 right-[0.9px] z-10"
                        style={{ width: "65px", height: "auto" }}
                      />
                    )}



                    {/* PopularAppsCard component */}
                    <div className="relative">
                      <PopularAppsCard

                        borderCard={app.status === "Installed" ? "1px solid rgb(184, 172, 241)" : null}
                        overallRating={app.overall_rating}
                        reviewsCount={app.rating_count}
                        downloadCount='100k'
                        imageUrl={app.app_icon || 'https://salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled-1150x647.png'}
                        title={app.app_name}
                        subtitle={app.slug}
                        backgroundColor="white"
                        titleColor="red"
                        reviewColor="black"

                        appDescription={` ${app.short_description}`}
                        subtitleColor='#7E8B9E'
                        onClick={() => onAppCardClick(app.slug, app.app_name, app.status, "popular_card")}
                      />
                    </div>
                  </div>

                ))}
              </div>
            </div>


            {shouldShowLoadMoreButton && (
              <div style={{ justifyContent: "center", display: "flex", marginTop: "30px" }}>
                <button
                  onClick={handleLoadMore}
                  style={{
                    width: '202px',
                    height: '52px',
                    background: '#735AE5',
                    border: '1px solid #00000000',
                    borderRadius: '8px',
                    opacity: 1,
                    fontSize: '20px',
                    padding: '10px 20px',
                    color: '#ffffff',
                    cursor: 'pointer',


                  }}
                >
                  Load More
                </button>
              </div>
            )}
          </div>



        )}
      </div>

      {/* Second div - Show on mobile view */}
      <div className="block md:hidden m-5">
        {/* Content of the second div */}
        {/* Content of the first div */}
        {currentPage === 0 && uniqueLoadedApps.length === 0 && uniqueLoadedApps.length === navSearchbardata!.length ? (
          // Render blank container when data is null on page 0
          <div style={{ padding: "20px", margin: "20px", }}>
            <AppProvider i18n={{}}>
              <div className="flex flex-col md:flex-row justify-center">Something went wrong</div>
            </AppProvider>
          </div>
        ) : currentPage === null && uniqueLoadedApps.length === null ? (
          // Render blank container when data is null on page 0
          <div style={{ padding: "20px", margin: "20px", }}>
            <AppProvider i18n={{}}>
              <div>Loading data....</div>
            </AppProvider>
          </div>
        ) : (
          // Render content when data is available



          <div className='container'>
            <div className='container'>
              <h1 style={{
                marginTop: "20px",
                fontSize: "32px",
                letterSpacing: "0px",
                opacity: "100",
                color: "#0B0757",
                fontFamily: "sfprobold"
              }}  >{loadedApps.length === 0 ? '' : mainTitle}</h1>
            </div>

            <div>
              <div style={{ marginTop: "18px", }} className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4'>
                {visibleApps.map((app, index) => (
                  <div key={index} style={{ position: "relative" }}>
                    {/* Image positioned above the right top of the card */}
                    {app.status === "Installed" && (
                      <img
                        src={install2}
                        alt="image"
                        className="absolute top-8 transform -translate-y-1/2 right-[0.9px] z-10"
                        style={{ width: "65px", height: "auto" }}
                      />
                    )}



                    {/* PopularAppsCard component */}
                    <div className="relative">
                      <PopularAppsCard

                        borderCard={app.status === "Installed" ? "1px solid rgb(184, 172, 241)" : null}
                        overallRating={app.overall_rating}
                        reviewsCount={app.rating_count}
                        downloadCount='100k'
                        imageUrl={app.app_icon || 'https://salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled-1150x647.png'}
                        title={app.app_name}
                        subtitle={app.slug}
                        backgroundColor="white"
                        titleColor="red"
                        reviewColor="black"
                        appDescription={` ${app.short_description}`}
                        subtitleColor='#7E8B9E'
                        onClick={() => onAppCardClick(app.slug, app.app_name, app.status, "popular_card")}
                      />
                    </div>
                  </div>

                ))}
              </div>
            </div>


            {shouldShowLoadMoreButton && (
              <div style={{ justifyContent: "center", display: "flex", marginTop: "30px" }}>
                <button
                  onClick={handleLoadMore}
                  style={{
                    width: '202px',
                    height: '52px',
                    background: '#735AE5',
                    border: '1px solid #00000000',
                    borderRadius: '8px',
                    opacity: 1,
                    fontSize: '20px',
                    padding: '10px 20px',
                    color: '#ffffff',
                    cursor: 'pointer',


                  }}
                >
                  Load More
                </button>
              </div>
            )}
          </div>



        )}

      </div>


    </>
  );
};

export default AllApps;

